import {SidebarItem} from "./index";
import {useState} from "react";
import {Link} from "react-router-dom";
import {Switch} from "../inputs";
import {PolLogo, PolTextLogo} from "../logo";
import {SIDEBAR_ROUTES} from "../../constants/routes";
import {ROOT_URL} from "../../constants/global";
import {useSelector} from "react-redux";

export default function Sidebar() {

    const [openSidebar, setOpenSidebar] = useState(true);

    const layout = useSelector(state => state.layout.data)

    const sidebarHandler = () => {
        setOpenSidebar(prevState => !prevState);
    }

    const changePanel = () => {
        window.location.replace(process.env.REACT_APP_EMPLOYER_URL);
    }

    return (

        <div
            className={`sticky top-[1.625rem] min-h-[37rem] h-[calc(100vh-3.5rem)] bg-pol-light mb-1.5 duration-300 whitespace-nowrap ${openSidebar ? "w-[16.313rem] min-w-[16.313rem] rounded-t-2xl rounded-b-[2.25rem]" : "w-[5.25rem] min-w-[5.25rem] rounded-2xl"}`}>
            {
                openSidebar ?
                    <button
                        onClick={sidebarHandler}
                        className="w-9 h-9 rounded-[0.563rem] bg-pol-light flex-center shadow-[0_5px_12px_4px_rgba(241,241,251,0.5)] absolute -left-[1.125rem] top-4">
                        <i className="icon-double-right-arrow text-pol-purple text-xs"/>
                    </button> : null
            }
            <div
                className={`ltr pol-scroll flex flex-col overflow-y-auto py-4 h-full ${openSidebar ? "px-5" : "px-4"}`}>
                <div
                    className={`rtl relative flex gap-x-2.5 w-full items-center pb-3 ${openSidebar ? "" : "flex-col"}`}>
                    <Link to={ROOT_URL + "/dashboard"} className="group flex items-center gap-x-1.5">
                        <PolLogo width={openSidebar ? 34 : 38} height={openSidebar ? 24 : 38}
                                 classes="group-hover:fill-pol-main-purple duration-300"/>
                        {
                            openSidebar ?
                                <PolTextLogo classes="group-hover:fill-pol-main-purple duration-300"/> : null
                        }
                    </Link>
                    {
                        openSidebar ?
                            null
                            :
                            <button
                                onClick={sidebarHandler}
                                className="w-9 h-9 rounded-[0.563rem] bg-pol-light flex-center border border-pol-light-purple mt-2.5">
                                <i className="icon-double-right-arrow rotate-180 text-pol-purple text-xs"/>
                            </button>
                    }
                </div>
                <div className="rtl">
                    <div className="flex-between py-3 border-y border-y-pol-light-purple-2">
                        {
                            openSidebar ? <h2 className="text-sm font-semibold text-pol-dark">پنل فریلنسر</h2> : null
                        }
                        <Switch
                            classes={{
                                firstLabelClasses: "text-pol-main-dark-color",
                                secondLabelClasses: "text-pol-main-dark-color",
                                barClasses: "before:bg-pol-main-dark-color bg-pol-light-orange-2"
                            }}
                            checked
                            onChange={changePanel}
                        />
                    </div>
                    <nav className={`mt-4 flex flex-col gap-y-2.5 sidebar-links ${openSidebar ? "" : "items-center"}`}>
                        {
                            SIDEBAR_ROUTES.filter(route => route.showInMenu).map(item => (
                                <SidebarItem
                                    layout={layout}
                                    opened={openSidebar}
                                    {...item} />
                            ))
                        }
                    </nav>
                </div>
                <div className="rtl flex-1 flex items-end mt-10">
                    <div className="border-t border-t-pol-light-purple-2 pt-3.5 text-center w-full">
                        {
                            layout.username ?
                                <Link
                                    to={process.env.REACT_APP_MAIN_URL + `/profile/${layout.username}`}
                                    className="font-semibold text-sm text-pol-dark-2 hover:text-pol-main-purple"
                                >
                                    {openSidebar ?
                                        <p>
                                            <i className="icon-logout ml-4"/>
                                            <span>لندینگ پیج من</span>
                                        </p> : <i className="icon-logout"/>}
                                </Link> : null
                        }

                    </div>
                </div>
            </div>

            <div
                className={`absolute bottom-0 h-1.5 bg-pol-main-color rounded-t-xl duration-300 ${openSidebar ? "right-[calc(50%-5.281rem)] w-[10.563rem]" : "right-[calc(50%-1.406rem)] w-[2.813rem]"}`}/>
        </div>
    )
}
